import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

//import images
import logoDark from "../assets/images/matrix-vision-logo.png";

const Footer = () => {
  const credits = window.__ENV && window.__ENV.credits;
  return (
    <React.Fragment>
      <section className="bg-footer bg-light">
        <Container>
          <Row className="text-center d-flex align-items-center">
            {/* <Col md={6}>
              <div className="text-sm-start mt-3 mt-sm-0">
                <img src={logoDark} alt="" height="50" />
              </div>
            </Col> */}
            <Col md={12} className="d-flex gap-1 justify-content-center">
              <div className="text-sm-end mt-3 mt-sm-0">
                <p className="text-muted mb-0">
                  © {new Date().getFullYear()} {credits}.
                </p>
              </div>
              {/* <div>
                <Link className="text-muted mb-0 link-hover" to="/privacy-policy">
                  Privacy Policy
                </Link>
              </div>
              <div>
                <Link className="text-muted mb-0 link-hover" to="/terms-conditions">
                  Terms and  Conditions
                </Link>
              </div> */}
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Footer;
